import { render } from "./signdata.vue?vue&type=template&id=1176c0ea&scoped=true"
import script from "./signdata.vue?vue&type=script&lang=js"
export * from "./signdata.vue?vue&type=script&lang=js"

import "./signdata.vue?vue&type=style&index=0&id=1176c0ea&lang=less&scoped=true"

import exportComponent from "/Users/yangjinlong/shthn/zzdxs-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1176c0ea"]])

export default __exports__